/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

// Core imports
import React, { Fragment, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

// Component imports
import { Button, Card, Col, Form, Input, Row, Typography } from 'antd';
import { MailOutlined, UserOutlined } from '@ant-design/icons';
import GlobalFooter from '../components/Layout/GlobalFooter';
import DocumentTitle from '../components/DocumentTitle';

// Misc imports
import AppLogo from '../assets/logo-full.svg';
import { NAV_ROOT } from '../constants/navigation';
import { useForgotPasswordMutation } from '../store/forgotPassword/forgotPasswordApi';

// Constant declarations
const baseClassName = 'login-screen';

const ForgotPasswordScreen = () => {
  const { currentUser } = useSelector((state) => state.auth);
  const isAuthenticated = !!currentUser;
  const navigate = useNavigate();
  const { t } = useTranslation();

  const [form] = Form.useForm();
  const [displayMessage, setDisplayMessage] = useState(false);

  const [forgotPassword] = useForgotPasswordMutation();

  useEffect(() => {
    if (isAuthenticated) {
      navigate(NAV_ROOT);
    }
  }, [isAuthenticated, currentUser]);

  const onFinish = async (values) => {
    await forgotPassword({ data: values });
    setDisplayMessage(true);
  };

  return (
    <div className={baseClassName}>
      <DocumentTitle title={t('Forgot Password')} />

      <Row justify="center">
        <img src={AppLogo} alt="logo" width={200} className="pt-10 mt-10 mb-10" />
      </Row>

      <Row justify="center">
        <Col xs={24} sm={20} md={12} lg={12} xl={7}>
          <Card
            title={(
              <Row justify="center">
                {t('Forgot Password')}
              </Row>
            )}
            bordered={false}
          >
            {
              !displayMessage ? (
                <Fragment>
                  <Row justify="center mb-5">
                    {t('Please enter your email to reset your password')}
                  </Row>

                  <Form
                    form={form}
                    name="forgotPasswordForm"
                    onFinish={onFinish}
                  >
                    <Form.Item
                      name="email"
                      rules={[{
                        required: true,
                        type: 'email',
                        message: t('Please enter your email.')
                      }]}
                    >
                      <Input name={['email']} size="large" prefix={<UserOutlined className="text-secondary mr-2" />} />
                    </Form.Item>

                    <Button type="primary" htmlType="submit" size="large" block>
                      {t('Submit')}
                    </Button>
                  </Form>
                </Fragment>
              ) : (
                <div className="text-center">
                  <Typography.Text className="mb-0 fs-xxxxl">
                    <MailOutlined />
                  </Typography.Text>
                  <h2>{t('Please check your email.')}</h2>
                </div>
              ) }
          </Card>
        </Col>
      </Row>

      <Row justify="center">
        <Col>
          <GlobalFooter />
        </Col>
      </Row>
    </div>
  );
};

export default ForgotPasswordScreen;
